<template>
    <modal v-model="show" max-width="90%" :has-padding="false">
        <div>
            <div class="header">
                <div class="select-wrapper">
                    <app-select
                        v-model="answer"
                        data-title="Selecione"
                        :data-search="false"
                        :data-items="dropdownItems"
                        :clearable="false"
                    />

                    <button
                        class="btn btn-extra-round btn-primary"
                        @click="reload"
                    >
                        {{ $t("message.generics.message.fetchData") }}
                    </button>
                </div>
                <i
                    class="mdi mdi-file-download-outline mr-4"
                    v-tooltip.auto="$t('message.generics.message.exportCsv')"
                    @click="download"
                ></i>
            </div>
            <div class="modal-body">
                <v-data-table
                    :headers="headers"
                    :items="list"
                    :loading="loading"
                    :hide-actions="true"
                    :must-sort="true"
                    class="table-leads"
                    no-data-text=""
                    no-results-text=""
                    sort-icon="mdi-chevron-down"
                >
                    <v-progress-linear
                        slot="progress"
                        :color="providerColor"
                        indeterminate
                    />

                    <template slot="items" slot-scope="props">
                        <answers-statistics-table-item
                            :data-item="props.item"
                        ></answers-statistics-table-item>
                    </template>

                    <template slot="footer">
                        <infinite-loading
                            :identifier="infiniteId"
                            @infinite="load"
                        >
                            <div slot="no-results">
                                {{ $t("message.generics.message.noData") }}
                            </div>
                            <div slot="no-more"></div>
                        </infinite-loading>
                    </template>
                </v-data-table>
            </div>
        </div>
    </modal>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import EventBus from "@packages/event-bus/index";
import AppSelect from "@components/Select";
import AnswersStatisticsTableItem from "./components/AnswerStatisticTableItem";
import loadsOnFilterUpdate from "@mixins/loads-on-filter-update";
import Modal from "@/components/generic/Modal";
import provider from "@mixins/provider";

export default {
    components: {
        AnswersStatisticsTableItem,
        AppSelect,
        InfiniteLoading,
        Modal,
    },

    data() {
        return {
            page: 0,
            loading: false,
            show: false,
            answer: "",
            mode: "",
            entity: "answeradvertising",
            headers: [],

            dropdownItems: [],

            list: [],

            infiniteId: +new Date(),

            filtersLoaded: false,
        };
    },

    watch: {
        answer(answer) {
            this.$store.state.answeradvertising.filters.answer = answer;
        },
        filters() {
            this.reload();
        },
        headers() {},
    },

    computed: {
        filters() {
            return this.$store.state.answeradvertising.filters;
        },
        statistcsFilter() {
            return this.$store.state.statistics.filters;
        },
    },

    mixins: [loadsOnFilterUpdate, provider],

    methods: {
        reload() {
            this.list = [];
            this.page = 0;
            this.infiniteId++;
        },
        async load($state) {
            if (this.filtersLoaded) {
                this.loading = true;

                try {
                    const list = await this.$api.answeradvertising.list({
                        page: this.page,
                        filters: {
                            ...this.filters,
                            ...this.statistcsFilter,
                        },
                    });

                    if (list.length) {
                        this.list.push(...list);

                        this.page++;

                        if ($state) {
                            $state.loaded();
                        }
                    } else {
                        if ($state) {
                            $state.complete();
                        }
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    this.loading = false;
                }
            }
        },

        async download() {
            const csv = await this.fetchCsv();
            const link = this.createElement(csv);
            link.click();
        },

        async fetchCsv() {
            return this.$api.answeradvertising.csv({ filters: this.filters }); // this.$loader.leads.csv({filters: this.filters})
        },

        createElement(csv) {
            const url = window.URL.createObjectURL(new Blob([csv]));
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", "respostas-clientes.csv");
            document.body.appendChild(link);

            return link;
        },
        openModalAnswersHandler(dataAnswer) {
            this.filtersLoaded = false;
            this.show = true;
            this.$store.state.answeradvertising.filters.mode = dataAnswer.mode;
            this.$store.state.answeradvertising.filters.interactionId =
                dataAnswer.interactionId;
            this.$store.state.answeradvertising.filters.advertisingId =
                dataAnswer.advertisingId;
            this.$store.state.answeradvertising.filters.answer =
                dataAnswer.answer;
            this.$store.state.answeradvertising.filters.date =
                this.$store.state.statistics.filters.date;
            this.$store.state.answeradvertising.filters.devices =
                this.$store.state.statistics.filters.devices;

            this.answer = dataAnswer.answer;
            this.dropdownItems = [];
            dataAnswer.answers.forEach((item) => {
                this.dropdownItems.push({ id: item, label: item });
            });

            if (dataAnswer.mode == "ULTIMA") {
                this.headers = [
                    {
                        text: this.$t("message.generics.message.name"),
                        value: "nome",
                        width: 230,
                    },
                    {
                        text: this.$t("message.statistics.message.gender"),
                        value: "sexo",
                        width: 110,
                    },
                    {
                        text: this.$t("message.statistics.message.birthDate"),
                        value: "dataNascimento",
                        width: 160,
                    },
                    {
                        text: this.$t("message.generics.message.email"),
                        value: "email",
                        width: 240,
                    },
                    {
                        text: this.$t("message.generics.message.phoneNumber"),
                        value: "telefone",
                        width: 130,
                    },
                    { text: "Data do acesso", value: "dataAcesso", width: 140 },
                ];
            } else {
                this.headers = [
                    {
                        text: this.$t("message.generics.message.name"),
                        value: "nome",
                        width: 270,
                    },
                    {
                        text: this.$t("message.statistics.message.gender"),
                        value: "sexo",
                        width: 130,
                    },
                    {
                        text: this.$t("message.statistics.message.birthDate"),
                        value: "dataNascimento",
                        width: 180,
                    },
                    {
                        text: this.$t("message.generics.message.email"),
                        value: "email",
                        width: 270,
                    },
                    {
                        text: this.$t("message.generics.message.phoneNumber"),
                        value: "telefone",
                        width: 160,
                    },
                ];
            }

            this.filtersLoaded = true;

            this.reload();
        },
    },

    mounted() {
        EventBus.$on("OPEN_MODAL_ANSWERS", this.openModalAnswersHandler);
    },

    beforeDestroy() {
        EventBus.$off("OPEN_MODAL_ANSWERS", this.openModalAnswersHandler);
    },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.select-wrapper {
    display: flex;
    align-items: center;

    .dropdown {
        margin-right: 10px;

        ::v-deep .dropdown-menu {
            right: -10%;
        }
    }
}

.card-footer {
    // display: flex;
    // align-items: center;
    // justify-content: center;
    padding-bottom: 15px;
}

.header {
    padding: 10px 50px 0 50px;
    height: 60px;
    display: flex;
}

.header span {
    padding-top: 10px;
}

.mdi {
    margin: 0px 0 0 auto;
    font-size: 38px;
    color: $grey-6;
    cursor: pointer;

    &.active {
        color: $blue-primary;
    }

    &.mdi-view-grid {
        font-size: 22px;
    }
}
/* .modal-round .v-card .card-body {
  min-height: 250px;
} */

.v-pagination {
    margin: 10px 0 0 auto;
    padding-bottom: 20px;
}

.table-leads {
    max-height: 500px;
    overflow: auto;
    border-radius: 0 0 40px 40px;
}
</style>
